module.exports = __webpack_public_path__ + "static/img/7.ee7baa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/7.png
// module id = Pm9D
// module chunks = 0